import { useEffect, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate, useParams } from 'react-router';

import { Avatar, Box, Button, Card, CardContent, CardHeader, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from '@syncfusion/ej2-react-documenteditor';
import { DropDownButton, ItemModel } from '@syncfusion/ej2-react-splitbuttons';

import moment from 'moment';

import { DefaultDocumentEditor } from '../../../helpers/DefaultDocumentEditor';
import { TabPanel, TabProps } from '../../../helpers/TabPanel';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { DialogActionsStyle, DialogContentStyle } from '../../../styles/DialogStyle';

import { Layout } from '../../../components/Layout';
import { BoxProcesoCancelado } from '../../../components/BoxProcesoCancelado';
import { BoxProcesoTerminado } from '../../../components/BoxProcesoTerminado';
import { BoxHeaderInformacion } from '../../../components/BoxHeaderInformacion';
import { BoxProcesoNoEncontrado } from '../../../components/BoxProcesoNoEncontrado';
import { BoxInformacionExpediente } from '../../../components/BoxInformacionExpediente';
import { CircularProgressIndicator } from '../../../components/CircularProgressIndicator';
import { InfoField } from '../../../components/InfoField';

import { Notificacion } from '../ui/Notificacion';

import { IncidentesPendientes } from '../../../connections/tribunal/IncidenteConnection';
import { ObtenerSentidoFallo } from '../../../connections/catalogos/SentidoFalloConnection';
import { ObtenerMediosImpugnacionSentencia } from '../../../connections/tribunal/MedioImpugnacionConnection';
import { ActualizarEstatusSentecia, GuardarSentencia, DetalleSentencia } from '../../../connections/sentencia/SentenciaConnection';

import { SentidoFalloProps } from '../../../interfaces/catalogos/SentidoFalloInterface';
import { NotificacionesProps } from '../../../interfaces/notificaciones/NotificacionesInterface';
import { defaultIncidente, IncidenteProps } from '../../../interfaces/tribunal/IncidenteInterface';
import { defaultMedioImpugnacion, MedioImpugnacionProps } from '../../../interfaces/tribunal/MedioImpugnacionInterface';
import { ActualizarSentenciaParams, defaultSentencia, SentenciaProps, UsuarioObservacionesProps } from '../../../interfaces/sentencia/SentenciaInterface';

DocumentEditorContainerComponent.Inject(Toolbar);

interface ItemModelModif extends ItemModel {
    value?: string;
}

const edit = false;

const chipStyle = {
    display: 'flex', flexDirection: 'column', gap: 0.5,
    flex: 1,
    px: 2, py: 1,
    borderRadius: 1,
    backgroundColor: 'action.hover',
    border: '1px solid',
    borderColor: 'divider',
} as const;

export const AutorizarSentenciaPage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { Id } = useParams();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );
    const dropCampos = useRef<DropDownButton>( null );
    const contenidoRef = useRef( '' );

    const [value, setValue] = useState( 0 );

    const [sentencia, setSentencia] = useState<SentenciaProps>( defaultSentencia )

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );
    const [loadingRegresar, setLoadingRegresar] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [autorizar, setAutorizar] = useState( true );
    const [observaciones, setObservaciones] = useState( '' );
    const [observacionesUsuarios, setObservacionesUsuarios] = useState<UsuarioObservacionesProps[]>( [] );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );
    const [openDialogConfirmacionRegresar, setOpenDialogConfirmacionRegresar] = useState( false );

    const [notificaciones, setNotificaciones] = useState<NotificacionesProps[]>( [] );

    //----------------------------------------------------------------------------------------------------------------------------------------

    const [resuelveRecurso, setResuelveRecurso] = useState( false );

    const [medioImpugnacion, setMedioImpugnacion] = useState( 0 );
    const [medioImpugnacionTemp, setMedioImpugnacionTemp] = useState( 0 );
    const [medioImpugnacionArray, setMedioImpugnacionArray] = useState<MedioImpugnacionProps[]>( [] );

    const [sentidoFallo, setSentidoFallo] = useState( 0 );
    const [sentidoFalloArray, setSentidoFalloArray] = useState<SentidoFalloProps[]>( [] );

    const [resuelveIncidente, setResuelveIncidente] = useState( false );
    const [incidente, setIncidente] = useState( 0 );
    const [incidenteArray, setIncidenteArray] = useState<IncidenteProps[]>( [] );

    const { tipoRecurso, tipoResolucion, recurrente, fechaAdmision } =
        medioImpugnacionArray.find( ({ idMedioImpugnacion }) => idMedioImpugnacion === medioImpugnacion ) ?? defaultMedioImpugnacion;

    const { secretario, fecha } =
        incidenteArray.find( ({ idIncidente }) => idIncidente === incidente ) ?? defaultIncidente;

    //----------------------------------------------------------------------------------------------------------------------------------------

    let Toolbar: ( CustomToolbarItemModel | ToolbarItem )[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
            prefixIcon: 'e-icons e-drop-down',
        }
    ];

    const validateFields = () => {

        let valid = true;

        if ( !autorizar && observaciones.trim() === '' ) {

            dispatch( openSnackbar({ message: 'Debes escribir las observaciones', variant: 'warning' }) );
            valid = false;

        }

        return valid;
    }

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => {

        if ( value === 0 && newValue !== 0 ) {

            const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

            contenidoRef.current = serialized;
        }

        setValue( newValue );
    }

    const Guardar = async () => {

        const params: ActualizarSentenciaParams = {
            idSentencia: Id ?? '',
            idPlantilla: sentencia.idPlantilla ?? 0,
            contenido: syncfusionEditor?.current?.documentEditor.serialize() ?? '',
            idSentidoSentencia: sentencia.idSentidoSentencia,
            perspectivaGenero: sentencia?.perspectivaGenero,

            resuelveRecurso,
            idMedioImpugnacion: medioImpugnacion,
            idSentidoFallo: sentidoFallo,

            resuelveIncidente,
            idIncidente: incidente,
        }

        return await GuardarSentencia( params );
    }

    const handleGuardar = async () => {

        setLoadingGuardar( true );

        await Guardar().then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch(openSnackbar({ message: message, variant: 'success' }));
                    setLoadingGuardar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingGuardar( false );

                }

            }, 700);

        });

    }

    const handleFinalizar = async () => {

        const validate = validateFields();

        if ( !validate ) return;

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }) );
                setLoadingFinalizar( false );

            }, 700);

            return;
        }

        await ActualizarEstatusSentecia({ idSentencia: Id ?? '', idEstatus: 39, observaciones: '' }).then(resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

                if ( success ) {

                    if ( asignadoMismoUsuario ) {

                        navigate(`/sentencia/visualizar/${ Id ?? '' }`);

                    }
                    else {

                        setProcesoTerminado( true );
                        setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

                    }

                    setLoadingFinalizar( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const handleRegresar = async () => {

        const validate = validateFields();

        if ( !validate ) return;

        setLoadingRegresar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }) );
                setLoadingRegresar( false );

            }, 700);

            return;
        }

        await ActualizarEstatusSentecia({ idSentencia: Id ?? '', idEstatus: 37, observaciones }).then(resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

                if ( success ) {

                    if ( asignadoMismoUsuario ) {

                        navigate(`/sentencia/elaborar/${ Id ?? '' }`);

                    }
                    else {

                        setProcesoTerminado( true );
                        setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

                    }

                    setLoadingRegresar( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingRegresar( false );

                }

            }, 700);

        });

    }

    //------------------------------------------------------------------------------------------------------------------------------------------

    const handleResuelveRecurso = ( value: boolean ) => {

        setMedioImpugnacion( 0 );
        setIncidente( 0 );
        setSentidoFallo( 0 );
        setResuelveRecurso( value );
        setResuelveIncidente( false );
    }

    const handleResuelveIncidente = ( value: boolean ) => {

        setIncidente( 0 );
        setMedioImpugnacion( 0 );
        setResuelveIncidente( value );
        setResuelveRecurso( false );
    }

    //--------------------------------------------- funciones para el editor de text --------------------------------------------------

    const configurarEditor = ( contenido?: string ) => {

        if ( !syncfusionEditor.current ) return;

        syncfusionEditor.current.documentEditor.open( contenido ?? DefaultDocumentEditor() );
        syncfusionEditor.current.documentEditorSettings.showRuler = true;
        syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';

        dropCampos.current?.appendTo('#dropItem');
    };

    useEffect(() => {

        if ( !loading ) {

            configurarEditor( contenidoRef.current || undefined );

        }

    }, [ loading ]);

    useEffect(() => {

        if ( value === 0 && !loading && syncfusionEditor.current ) {

            if ( contenidoRef.current ) {
                syncfusionEditor.current.documentEditor.open( contenidoRef.current );
            }

        }

    }, [ value, loading ]);

    //----------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            await ObtenerSentidoFallo().then(resp => {
                setSentidoFalloArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerMediosImpugnacionSentencia({ idExpediente: sentencia.idExpediente }).then(resp => {
                setMedioImpugnacionArray( resp );
            });

        }

        if ( resuelveRecurso && sentencia.idExpediente !== 0 ) {
            Obtener();
        }

    }, [ resuelveRecurso, sentencia.idExpediente ]);

    useEffect(() => {

        if ( medioImpugnacionTemp !== 0 && medioImpugnacionArray.length !== 0 ) {
            setMedioImpugnacion( medioImpugnacionTemp );
        }

    }, [ medioImpugnacionTemp, medioImpugnacionArray.length ]);

    useEffect(() => {

        async function Obtener() {

            await IncidentesPendientes({ idExpediente: sentencia.idExpediente }).then(resp => {
                setIncidenteArray( resp );
            });

        }

        if ( resuelveIncidente && sentencia.idExpediente !== 0 ) {
            Obtener();
        }

    }, [ resuelveIncidente, sentencia.idExpediente ]);

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleSentencia( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setSentencia( resp );
                        setNotificaciones( resp.notificaciones );
                        setObservacionesUsuarios( resp.usuarioObservaciones );

                        setResuelveRecurso( resp.resuelveRecurso );
                        setMedioImpugnacionTemp( resp.idMedioImpugnacion );
                        setSentidoFallo( resp.idSentidoFallo );

                        setResuelveIncidente( resp.resuelveIncidente );
                        setIncidente( resp.idIncidente );

                        contenidoRef.current = resp.contenido;

                        const mkItem = (text: string, id: string, value: string): ItemModelModif[] =>
                            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];
                        const joinNames = (arr: string[]) => arr.join(', ');
                        const fmtDate = (d: any) => moment(d).format('DD-MM-YYYY');

                        let items: ItemModelModif[] = [
                            ...mkItem('Fecha Actual', '1', '[Fecha_Actual]'),
                            ...mkItem('Numero de sentencia', '2', resp.numeroSentencia),
                        ];

                        if ( resp.idExpediente !== 0 ) {
                            const { expediente: e } = resp;
                            items.push(
                                ...mkItem('Número de Expediente', '4', e.numeroExpediente),
                                ...mkItem('Tipo de Juicio', '6', e.tipoJuicio),
                                ...mkItem('Juzgado Origen', '10', e.juzgadoOrigen),
                                ...mkItem('Fecha del Expediente', '11', fmtDate(e.fecha)),
                                ...mkItem('Actor(es)', '12', joinNames( e.actores )),
                                ...mkItem('Demandado(s)', '13', joinNames( e.demandados )),
                                ...mkItem('Juez', '13', e.juez),
                            );
                            if ( e.numeroFolio )            items.push(...mkItem('Número de Folio', '14', e.numeroFolio));
                            if ( e.secretarioTramite )      items.push(...mkItem('Secretario de Tramite', '5', e.secretarioTramite));
                            if ( e.secretarioTramiteMenor ) items.push(...mkItem('Secretario de Tramite Menor', '7', e.secretarioTramiteMenor));
                            if ( e.secretarioEjecucion )    items.push(...mkItem('Secretario de Ejecucion', '15', e.secretarioEjecucion));
                        }

                        if ( items[items.length - 1]?.separator ) { items.pop(); }

                        dropCampos.current = new DropDownButton({
                            items: items,
                            beforeItemRender: (data: ItemModelModif) => {
                                return `<div>
                                                <span class="e-menu-icon ${data.iconCss}"></span>
                                                <span class="custom-class" >${data.text}</span>
                                            </div>`;
                            },
                            select: (args) => syncfusionEditor.current?.documentEditor.editor.insertText( args?.item.value ?? "" ),
                        },);

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 38 ) {
                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 38 ) {
                            setLoading( false );
                        }
                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        Obtener();

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Sentencia' }, { text: 'Autorizar sentencia' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ sentencia.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label='Sentencia' {...TabProps(0)} />
                                        <Tab label='Notificación' {...TabProps(1)} />
                                        <Tab label="Información del expediente" {...TabProps(2)} />

                                    </Tabs>

                                </Box>

                                <div role="tabpanel" hidden={ value !== 0 } id="vertical-tabpanel-0" aria-labelledby="vertical-tab-0" style={{ padding: '16px 0' }}>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion
                                            numeroSeguimiento={ `GSE-${ sentencia.idSentencia }` }
                                            fecha={ sentencia.fecha ?? new Date() }
                                            juez={ sentencia.juez }
                                        />

                                        <Grid container spacing={ 3 } mt={ 2 }>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Número de Sentencia (Resolución)"
                                                    value={ sentencia.numeroSentencia }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Tipo de Sentencia"
                                                    value={ `Sentencia ${ sentencia.tipoSentencia }` }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Fecha de citación"
                                                    value={ sentencia.fechaCitacion ? moment( sentencia.fechaCitacion ).format('DD-MM-YYYY hh:mm a') : '' }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Sentido de sentencia"
                                                    value={ sentencia.sentidoSentencia }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="¿Con perspectiva género?"
                                                    value={ sentencia.perspectivaGenero ? 'Si' : 'No' }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}> </Grid>

                                            {
                                                sentencia.plantilla
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Plantilla"
                                                            value={ sentencia.plantilla }
                                                        />

                                                    </Grid>
                                            }

                                            {
                                                ( sentencia?.idTipoSentencia === 2 && sentencia?.medioImpugnacion === true )
                                                &&
                                                    <>
                                                        {
                                                            edit
                                                            ?
                                                                <Grid size={{ md: 12, xs: 12 }}>

                                                                    <FormControl fullWidth>

                                                                        <Grid container spacing={ 3 }>

                                                                            <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                                <FormLabel sx={{ color: 'black' }} >¿La sentencia resuelve un recurso?</FormLabel>
                                                                            </Grid>

                                                                            <Grid size={{ md: 6, xs: 12 }}>

                                                                                <RadioGroup row >

                                                                                    <Grid container >

                                                                                        <Grid size={{ md: 6, xs: 6 }}>
                                                                                            <FormControlLabel value="Si" control={ <Radio checked={ resuelveRecurso } onChange={ () => handleResuelveRecurso( true ) } /> } label="Si" />
                                                                                        </Grid>

                                                                                        <Grid size={{ md: 6, xs: 6 }}>
                                                                                            <FormControlLabel value="No" control={ <Radio checked={ !resuelveRecurso } onChange={ () => handleResuelveRecurso( false ) } /> } label="No" />
                                                                                        </Grid>

                                                                                    </Grid>

                                                                                </RadioGroup>

                                                                            </Grid>

                                                                        </Grid>

                                                                    </FormControl>

                                                                </Grid>
                                                            :
                                                                <Grid size={{ md: 12, xs: 12 }}>

                                                                    <InfoField
                                                                        chip
                                                                        label="¿La sentencia resuelve un recurso?"
                                                                        value={ resuelveRecurso ? 'Si' : 'No' }
                                                                    />

                                                                </Grid>
                                                        }

                                                        {
                                                            resuelveRecurso
                                                            &&
                                                                <Grid size={{ md: 12, xs: 12 }} >

                                                                    <Card>

                                                                        <CardHeader
                                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                                            subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Información del recurso </Typography> }
                                                                        />

                                                                        <Divider />

                                                                        <CardContent>

                                                                            <Grid container spacing={ 3 }>

                                                                                <Grid size={{ md: 12, xs: 12 }} mt={ 1 }>

                                                                                    {
                                                                                        edit
                                                                                            ?
                                                                                            <FormControl fullWidth>

                                                                                                <InputLabel>Seleccione el recurso</InputLabel>

                                                                                                <Select
                                                                                                    label="Seleccione el recurso"
                                                                                                    value={ medioImpugnacion }
                                                                                                    onChange={ (e) => setMedioImpugnacion( e.target.value ) }
                                                                                                    renderValue={(selected) => {

                                                                                                        if (selected === 0) return 'Selecciona una opción';

                                                                                                        const recurso = medioImpugnacionArray.find(({ idMedioImpugnacion }) => idMedioImpugnacion === selected);

                                                                                                        return (
                                                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>

                                                                                                                <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                                    <Typography variant='caption' color='text.secondary'>Tipo</Typography>
                                                                                                                    <Typography variant='body2' fontWeight='bold'>{recurso?.tipoRecurso}</Typography>
                                                                                                                </Box>

                                                                                                                <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                                    <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                                                    <Typography variant='body2' fontWeight='bold'>{recurso?.tipoResolucion}</Typography>
                                                                                                                </Box>

                                                                                                                <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                                    <Typography variant='caption' color='text.secondary'>Admisión</Typography>
                                                                                                                    <Typography variant='body2' fontWeight='bold'>{recurso?.fechaAdmision ? moment(recurso?.fechaAdmision).format('DD-MM-YYYY') : ''}</Typography>
                                                                                                                </Box>

                                                                                                                <Box sx={{ pl: 1.5, flex: 1 }}>
                                                                                                                    <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                                                    <Typography variant='body2' fontWeight='bold'>{recurso?.recurrente}</Typography>
                                                                                                                </Box>

                                                                                                            </Box>
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    <MenuItem value={ 0 }>Selecciona una opción</MenuItem>

                                                                                                    {
                                                                                                        medioImpugnacionArray.map(({ idMedioImpugnacion, tipoRecurso, tipoResolucion, fechaAdmision, recurrente }) => (

                                                                                                            <MenuItem key={ idMedioImpugnacion } value={ idMedioImpugnacion }>

                                                                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, width: '100%' }}>

                                                                                                                    <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                                        <Typography variant='caption' color='text.secondary'>Tipo</Typography>
                                                                                                                        <Typography variant='body2' fontWeight='bold'>{tipoRecurso}</Typography>
                                                                                                                    </Box>

                                                                                                                    <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                                        <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                                                        <Typography variant='body2' fontWeight='bold'>{tipoResolucion}</Typography>
                                                                                                                    </Box>

                                                                                                                    <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                                        <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                                                        <Typography variant='body2' fontWeight='bold'>{fechaAdmision ? moment(fechaAdmision).format('DD-MM-YYYY') : ''}</Typography>
                                                                                                                    </Box>

                                                                                                                    <Box sx={{ pl: 1.5, flex: 1 }}>
                                                                                                                        <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                                                        <Typography variant='body2' fontWeight='bold'>{recurrente}</Typography>
                                                                                                                    </Box>

                                                                                                                </Box>

                                                                                                            </MenuItem>

                                                                                                        ))
                                                                                                    }

                                                                                                </Select>

                                                                                            </FormControl>
                                                                                            :
                                                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: 1.5 }}>

                                                                                                <Box sx={ chipStyle }>
                                                                                                    <Typography variant='caption' color='text.secondary'>Tipo de recurso</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>{tipoRecurso}</Typography>
                                                                                                </Box>

                                                                                                <Box sx={ chipStyle }>
                                                                                                    <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>{tipoResolucion}</Typography>
                                                                                                </Box>

                                                                                                <Box sx={ chipStyle }>
                                                                                                    <Typography variant='caption' color='text.secondary'>Fecha de admisión</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>
                                                                                                        {fechaAdmision ? moment(fechaAdmision).format('DD-MM-YYYY') : ''}
                                                                                                    </Typography>
                                                                                                </Box>

                                                                                                <Box sx={{ ...chipStyle, flex: 2 }}>
                                                                                                    <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>{recurrente}</Typography>
                                                                                                </Box>

                                                                                            </Box>
                                                                                    }

                                                                                </Grid>

                                                                                <Grid size={{ md: 12, xs: 12 }} >

                                                                                    {
                                                                                        edit
                                                                                            ?
                                                                                            <FormControl fullWidth>

                                                                                                <InputLabel>Sentido de fallo</InputLabel>

                                                                                                <Select
                                                                                                    label="Sentido de fallo"
                                                                                                    value={ sentidoFallo }
                                                                                                    onChange={ (e) => setSentidoFallo( e.target.value ) }
                                                                                                >
                                                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>

                                                                                                    {
                                                                                                        sentidoFalloArray
                                                                                                            .map(({ idSentidoFallo, descripcion }) => (
                                                                                                                <MenuItem key={ idSentidoFallo } value={ idSentidoFallo }>{descripcion}</MenuItem>
                                                                                                            ))
                                                                                                    }

                                                                                                </Select>

                                                                                            </FormControl>
                                                                                            :
                                                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: 1.5 }}>

                                                                                                <Box sx={ chipStyle }>
                                                                                                    <Typography variant='caption' color='text.secondary'>Sentido del fallo</Typography>
                                                                                                    <Typography variant='body2' fontWeight='bold'>{sentidoFalloArray.find(({ idSentidoFallo }) => idSentidoFallo === sentidoFallo)?.descripcion ?? ''}</Typography>
                                                                                                </Box>

                                                                                            </Box>
                                                                                    }

                                                                                </Grid>

                                                                            </Grid>

                                                                        </CardContent>

                                                                    </Card>

                                                                </Grid>
                                                        }

                                                    </>
                                            }

                                            {
                                                ( sentencia?.idTipoSentencia === 2 && sentencia?.incidente === true )
                                                &&
                                                    <Grid size={{ md: 12, xs: 12 }} >

                                                        <Card>

                                                            <CardHeader
                                                                sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                                subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Información del incidente </Typography> }
                                                            />

                                                            <Divider />

                                                            <CardContent>

                                                                <Grid container spacing={ 3 }>

                                                                    <Grid size={{ md: 12, xs: 12 }} >

                                                                        {
                                                                            edit
                                                                                ?
                                                                                <FormControl fullWidth>

                                                                                    <Grid container spacing={ 3 }>

                                                                                        <Grid size={{ md: 6, xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                                                            <FormLabel sx={{ color: 'black' }} >¿La sentencia resuelve un incidente?</FormLabel>
                                                                                        </Grid>

                                                                                        <Grid size={{ md: 6, xs: 12 }} >
                                                                                            <RadioGroup row >
                                                                                                <Grid container >
                                                                                                    <Grid size={{ md: 6, xs: 6 }} >
                                                                                                        <FormControlLabel value="Si" control={ <Radio checked={ resuelveIncidente === true } onChange={() => { handleResuelveIncidente(true); }} /> } label="Si" />
                                                                                                    </Grid>
                                                                                                    <Grid size={{ md: 6, xs: 6 }} >
                                                                                                        <FormControlLabel value="No" control={ <Radio checked={ resuelveIncidente === false } onChange={() => { handleResuelveIncidente(false); }} /> } label="No" />
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </RadioGroup>
                                                                                        </Grid>

                                                                                    </Grid>

                                                                                </FormControl>
                                                                                :
                                                                                <InfoField
                                                                                    chip
                                                                                    label="¿La sentencia resuelve un incidente?"
                                                                                    value={ resuelveIncidente ? 'Si' : 'No' }
                                                                                />
                                                                        }

                                                                    </Grid>

                                                                    {
                                                                        resuelveIncidente
                                                                            ?
                                                                            edit
                                                                                ?
                                                                                <Grid size={{ md: 12, xs: 12 }} >

                                                                                    <FormControl fullWidth>
                                                                                        <InputLabel>Seleccione el incidente</InputLabel>

                                                                                        <Select
                                                                                            label="Seleccione el incidente"
                                                                                            value={ incidente }
                                                                                            onChange={ (e) => setIncidente( e.target.value ) }
                                                                                            renderValue={(selected) => {

                                                                                                if (selected === 0) return 'Selecciona una opción';

                                                                                                const incidente = incidenteArray.find(({ idIncidente }) => idIncidente === selected);

                                                                                                return (
                                                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>

                                                                                                        <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                            <Typography variant='caption' color='text.secondary'>Secretario(a)</Typography>
                                                                                                            <Typography variant='body2' fontWeight='bold'>{incidente?.secretario}</Typography>
                                                                                                        </Box>

                                                                                                        <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                            <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                                            <Typography variant='body2' fontWeight='bold'>{incidente?.fecha ? moment(incidente?.fecha).format('DD-MM-YYYY') : ''}</Typography>
                                                                                                        </Box>

                                                                                                    </Box>
                                                                                                );
                                                                                            }}
                                                                                        >
                                                                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>

                                                                                            {
                                                                                                incidenteArray.map(({ idIncidente, secretario, fecha }) => (

                                                                                                    <MenuItem key={ idIncidente } value={ idIncidente }>

                                                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, width: '100%' }}>

                                                                                                            <Box sx={{ pr: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                                <Typography variant='caption' color='text.secondary'>Secretario(a)</Typography>
                                                                                                                <Typography variant='body2' fontWeight='bold'>{secretario}</Typography>
                                                                                                            </Box>

                                                                                                            <Box sx={{ px: 1.5, borderRight: '1px solid', borderColor: 'divider' }}>
                                                                                                                <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                                                <Typography variant='body2' fontWeight='bold'>{fecha ? moment(fecha).format('DD-MM-YYYY') : ''}</Typography>
                                                                                                            </Box>

                                                                                                        </Box>

                                                                                                    </MenuItem>

                                                                                                ))
                                                                                            }

                                                                                        </Select>

                                                                                    </FormControl>

                                                                                </Grid>
                                                                                :
                                                                                <Grid size={{ md: 12, xs: 12 }} >

                                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: 1.5 }}>

                                                                                        <Box sx={ chipStyle }>
                                                                                            <Typography variant='caption' color='text.secondary'>Secretario(a)</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{secretario}</Typography>
                                                                                        </Box>

                                                                                        <Box sx={ chipStyle }>
                                                                                            <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>
                                                                                                {fecha ? moment(fecha).format('DD-MM-YYYY') : ''}
                                                                                            </Typography>
                                                                                        </Box>

                                                                                    </Box>

                                                                                </Grid>

                                                                            : null
                                                                    }

                                                                </Grid>

                                                            </CardContent>

                                                        </Card>

                                                    </Grid>
                                            }

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <DocumentEditorContainerComponent
                                                    key='DocumentEditorContainer'
                                                    serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                    height='650'
                                                    ref={ syncfusionEditor }
                                                    enableToolbar={ true }
                                                    showPropertiesPane={ false }
                                                    toolbarItems={ Toolbar }
                                                    autoResizeOnVisibilityChange={ false }
                                                >
                                                </DocumentEditorContainerComponent>

                                            </Grid>

                                            {
                                                sentencia.observaciones
                                                &&
                                                    <Grid size={{ xs: 12, md: 12 }}>

                                                        <Card sx={{ p: 2 }}>

                                                            <Typography variant='h6' sx={{ mb: 2 }}>
                                                                Observaciones
                                                            </Typography>

                                                            <Stack spacing={ 2 }>

                                                                {
                                                                    observacionesUsuarios.map( ( { usuario, puesto, observacion, fecha }, i ) => (

                                                                        <Box key={ i } sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>

                                                                            <Avatar
                                                                                sx={{
                                                                                    width: 36,
                                                                                    height: 36,
                                                                                    fontSize: 12,
                                                                                    fontWeight: 500,
                                                                                    bgcolor: (theme) => theme.palette.primary.main,
                                                                                    color: 'white',
                                                                                }}
                                                                            >
                                                                                { usuario.split(' ').slice(0, 2).map(n => n[0]).join('') }
                                                                            </Avatar>

                                                                            <Box
                                                                                sx={{
                                                                                    flex: 1,
                                                                                    bgcolor: 'action.hover',
                                                                                    border: '0.5px solid',
                                                                                    borderColor: 'divider',
                                                                                    borderRadius: '0 15px 15px 15px',
                                                                                    px: 2,
                                                                                    py: 1.25,
                                                                                }}
                                                                            >
                                                                                <Typography variant='subtitle2' fontWeight={ 500 }>
                                                                                    { usuario } { puesto ? `(${ puesto })` : '' }
                                                                                </Typography>

                                                                                <Typography variant='body2' color='text.secondary' sx={{ mt: 0.5, lineHeight: 1.5 }}>
                                                                                    { observacion }
                                                                                </Typography>

                                                                                {
                                                                                    fecha
                                                                                    &&
                                                                                        <Typography variant='caption' color='text.disabled' sx={{ mt: 0.75, display: 'block' }}>
                                                                                            { moment( fecha ).format('DD-MM-YYYY hh:mm a') }
                                                                                        </Typography>
                                                                                }

                                                                            </Box>

                                                                        </Box>

                                                                    ))
                                                                }

                                                            </Stack>

                                                        </Card>

                                                    </Grid>
                                            }

                                            <Grid size={{ xs: 12, md: 12 }}>

                                                <Card sx={{ p: 1 }}>

                                                    <CardHeader
                                                        title={ <Typography variant='h5'>¿Desea autorizar la sentencia?</Typography> }
                                                        subheader={
                                                            <FormControl>
                                                                <RadioGroup row>

                                                                    <FormControlLabel
                                                                        label='Si'
                                                                        control={
                                                                            <Radio
                                                                                size='small'
                                                                                checked={ autorizar }
                                                                                onChange={ () => { setAutorizar( true ); setObservaciones( '' ); } }
                                                                            />
                                                                        }
                                                                    />

                                                                    <FormControlLabel
                                                                        label='No'
                                                                        control={
                                                                            <Radio
                                                                                size='small'
                                                                                checked={ !autorizar }
                                                                                onChange={ () => setAutorizar( false ) }
                                                                            />
                                                                        }
                                                                    />

                                                                </RadioGroup>
                                                            </FormControl>
                                                        }
                                                    />

                                                    <Collapse in={ !autorizar }>

                                                        <CardContent>

                                                            <TextField
                                                                fullWidth
                                                                multiline
                                                                rows={ 4 }
                                                                label='Observaciones'
                                                                variant='outlined'
                                                                value={ observaciones }
                                                                onChange={ (e) => setObservaciones( e.target.value ) }
                                                                slotProps={{
                                                                    input: { autoComplete: 'off' },
                                                                    inputLabel: { shrink: true },
                                                                }}
                                                            />

                                                        </CardContent>

                                                    </Collapse>

                                                </Card>

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            disabled={ autorizar || observaciones === '' }
                                                            onClick={ () => setOpenDialogConfirmacionRegresar( true ) }
                                                        >

                                                            Regresar sentencia a elaborar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            variant='outlined'
                                                            loading={ loadingGuardar }
                                                            onClick={ handleGuardar }
                                                        >
                                                            Guardar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'right' }}>
                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant='contained'
                                                            disabled={ !autorizar }
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>
                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </div>

                                <TabPanel value={ value } index={ 1 }>

                                    <Notificacion sentencia={ sentencia } notificaciones={ notificaciones } setNotificaciones={ setNotificaciones } edit={ false } />

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                        <BoxInformacionExpediente
                                            expediente={ sentencia.expediente }
                                        />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea firmar y finalizar la sentencia?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                        <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionRegresar }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea regresar a elaborar la sentencia?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingRegresar } onClick={ () => setOpenDialogConfirmacionRegresar( false ) }> Cancelar </Button>
                                        <Button loading={ loadingRegresar } onClick={ handleRegresar } variant='contained' > Aceptar </Button>
                                    </DialogActions>
                                </Dialog>
                            </>
            }

        </Layout>
    )
}
